/**
 * Emit a one-time warning when map/location features are used but
 * NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is empty. Never throws (parity with dday-invite guardrails).
 */
const warnedContexts = new Set<string>()
const MAPS_KEY_DOCS =
  'https://github.com/kiltechco/dday-web/blob/main/docs/GOOGLE_MAPS_SETUP.md'

/** One-time warn per context when key is missing; no throw. */
export function warnIfMapsKeyMissing(
  apiKey: string | undefined,
  context: string
): void {
  const resolved = typeof apiKey === 'string' ? apiKey.trim() : ''
  if (resolved.length > 0) return

  const key = `maps-key:${context}`
  if (warnedContexts.has(key)) return
  warnedContexts.add(key)

  const message = [
    '[dday-web] Google Maps API key is missing.',
    'Location/map features will use fallback input or be disabled.',
    `Set NEXT_PUBLIC_GOOGLE_MAPS_API_KEY in app config or platform env.`,
    `See docs/GOOGLE_MAPS_SETUP.md or ${MAPS_KEY_DOCS}`,
  ].join(' ')

  console.warn(message, { context })
}
